import { useState, useEffect } from "react";
import { Sidebar } from "../../components/sidebar";
import { Wrapper } from "../../components/wrapper";
import { Snackbar } from "../../components/snackbar";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import SettingsIcon from "@mui/icons-material/Settings";
import TireRepairIcon from "@mui/icons-material/TireRepair";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { DEFAULT_SNACK } from "../../utils/snacks";
import config from "../../config/api.config";

const vehicleTypeConfig = {
  gasolina_4x2: {
    icon: LocalGasStationIcon,
    color: "blue",
  },
  gasolina_4x4: {
    icon: DirectionsCarIcon,
    color: "green",
  },
  diesel_4x2: {
    icon: BuildCircleIcon,
    color: "orange",
  },
  diesel_4x4: {
    icon: SettingsIcon,
    color: "purple",
  },
  hibrido: {
    icon: TireRepairIcon,
    color: "green",
  },
  electrico: {
    icon: BuildCircleIcon,
    color: "blue",
  },
};

export const ServiceTypes = () => {
  const [selectedType, setSelectedType] = useState(null);
  const [serviceLists, setServiceLists] = useState([]);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snack, setSnackbar] = useState(DEFAULT_SNACK);
  const [showAddForm, setShowAddForm] = useState(false);
  const [editingService, setEditingService] = useState(null);
  const [newService, setNewService] = useState({
    title: "",
    interval: "",
    intervalNum: 0,
    description: "",
    isInspection: false,
  });

  useEffect(() => {
    fetchServiceLists();
  }, []);

  useEffect(() => {
    if (selectedType) {
      console.log('🔍 Tipo seleccionado:', selectedType.name, 'ID:', selectedType._id);
      setServices(selectedType.services || []);
    }
  }, [selectedType]);

  const fetchServiceLists = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`${config.apiUrl}/service-list`);
      if (data.success) {
        setServiceLists(data.data);
        console.log('📋 Service lists cargadas:', data.data.length);
        data.data.forEach(list => {
          console.log(`  - ${list.name}: ${list.services?.length || 0} servicios`);
        });
      }
    } catch (err) {
      console.error("Error fetching service lists:", err);
      setSnackbar({
        visible: true,
        severity: "error",
        message: "Error al cargar las listas de servicios",
      });
      setTimeout(() => setSnackbar(DEFAULT_SNACK), 3000);
    } finally {
      setLoading(false);
    }
  };

  const getServiceListId = () => {
    return selectedType?._id;
  };

  const handleAddService = async () => {
    if (!newService.title || (!newService.isInspection && !newService.interval)) {
      setSnackbar({
        visible: true,
        severity: "error",
        message: newService.isInspection ? "El título es requerido" : "Complete título e intervalo",
      });
      setTimeout(() => setSnackbar(DEFAULT_SNACK), 3000);
      return;
    }

    try {
      setLoading(true);
      const listId = getServiceListId();
      
      const serviceData = {
        title: newService.title,
        interval: newService.isInspection ? "0" : newService.interval,
        intervalNum: newService.isInspection ? 0 : newService.intervalNum,
        description: newService.description,
        date: "",
        worker: "-",
        nextService: "",
        nextServiceNum: null,
        reset: false,
      };

      const { data } = await axios.post(
        `${config.apiUrl}/service-list/${listId}/services`,
        serviceData
      );

      if (data.success) {
        setServices(data.data.services);
        setNewService({ title: "", interval: "", intervalNum: 0, description: "", isInspection: false });
        setShowAddForm(false);
        setSnackbar({
          visible: true,
          severity: "success",
          message: "Servicio agregado exitosamente",
        });
        fetchServiceLists();
      }
    } catch (err) {
      setSnackbar({
        visible: true,
        severity: "error",
        message: "Error al agregar servicio",
      });
    } finally {
      setLoading(false);
      setTimeout(() => setSnackbar(DEFAULT_SNACK), 3000);
    }
  };

  const handleUpdateService = async (serviceId) => {
    try {
      setLoading(true);
      const listId = getServiceListId();
      
      const { data } = await axios.put(
        `${config.apiUrl}/service-list/${listId}/services/${serviceId}`,
        editingService
      );

      if (data.success) {
        setServices(data.data.services);
        setEditingService(null);
        setSnackbar({
          visible: true,
          severity: "success",
          message: "Servicio actualizado exitosamente",
        });
        fetchServiceLists();
      }
    } catch (err) {
      setSnackbar({
        visible: true,
        severity: "error",
        message: "Error al actualizar servicio",
      });
    } finally {
      setLoading(false);
      setTimeout(() => setSnackbar(DEFAULT_SNACK), 3000);
    }
  };

  const handleDeleteService = async (serviceId) => {
    if (!window.confirm("¿Estás seguro de eliminar este servicio?")) return;

    try {
      setLoading(true);
      const listId = getServiceListId();
      
      const { data } = await axios.delete(
        `${config.apiUrl}/service-list/${listId}/services/${serviceId}`
      );

      if (data.success) {
        setServices(data.data.services);
        setSnackbar({
          visible: true,
          severity: "success",
          message: "Servicio eliminado exitosamente",
        });
        fetchServiceLists();
      }
    } catch (err) {
      setSnackbar({
        visible: true,
        severity: "error",
        message: "Error al eliminar servicio",
      });
    } finally {
      setLoading(false);
      setTimeout(() => setSnackbar(DEFAULT_SNACK), 3000);
    }
  };

  const handleIntervalChange = (value, isNew = false) => {
    const cleaned = value.replace(/\D/g, "");
    const formatted = cleaned.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    const num = parseInt(cleaned) || 0;

    if (isNew) {
      setNewService({ ...newService, interval: formatted, intervalNum: num });
    } else {
      setEditingService({ ...editingService, interval: formatted, intervalNum: num });
    }
  };

  return (
    <div className="flex min-h-screen bg-sidebar-bg">
      <Sidebar />
      <div className="flex-1 flex flex-col p-4">
        <Wrapper>
          <div className="flex-1 p-6 lg:p-8">
            <div className="max-w-7xl mx-auto">
              <div className="mb-8">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-10 h-10 rounded-lg bg-blue-600 flex items-center justify-center">
                    <BuildCircleIcon className="text-white" fontSize="small" />
                  </div>
                  <h1 className="text-3xl font-bold text-white">
                    Tipos de Servicio
                  </h1>
                </div>
                <p className="text-gray-400 text-sm mt-1">
                  Categorías de mantención según tipo de vehículo
                </p>
              </div>

              {loading && serviceLists.length === 0 ? (
                <div className="text-center py-12">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
                  <p className="text-gray-400 mt-4">Cargando tipos de servicio...</p>
                </div>
              ) : serviceLists.length === 0 ? (
                <div className="text-center py-12 bg-sidebar-accent/30 rounded-xl border border-sidebar-accent">
                  <BuildCircleIcon className="text-gray-600 mx-auto mb-4" sx={{ fontSize: 60 }} />
                  <p className="text-gray-400">No hay tipos de servicio configurados</p>
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                  {serviceLists.map((list) => {
                    const config = vehicleTypeConfig[list.vehicleType] || {
                      icon: BuildCircleIcon,
                      color: "blue",
                    };
                    const Icon = config.icon;
                    const colorClasses = {
                      blue: "from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800",
                      green: "from-green-600 to-green-700 hover:from-green-700 hover:to-green-800",
                      orange: "from-orange-600 to-orange-700 hover:from-orange-700 hover:to-orange-800",
                      purple: "from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800",
                    };

                    return (
                      <button
                        key={list._id}
                        onClick={() => setSelectedType(list)}
                        className={`p-6 rounded-xl border ${
                          selectedType?._id === list._id
                            ? "border-white shadow-lg scale-105"
                            : "border-sidebar-accent"
                        } bg-gradient-to-br ${
                          colorClasses[config.color]
                        } transition-all duration-200 hover:shadow-lg group`}
                      >
                        <div className="flex flex-col items-center text-center gap-4">
                          <div className="p-4 bg-white/10 rounded-full group-hover:scale-110 transition-transform">
                            <Icon className="text-white" sx={{ fontSize: 40 }} />
                          </div>
                          <div>
                            <h3 className="text-lg font-bold text-white mb-2">
                              {list.name}
                            </h3>
                            <p className="text-sm text-white/80">
                              {list.description}
                            </p>
                            <p className="text-xs text-white/60 mt-2">
                              {list.services?.length || 0} servicio{list.services?.length !== 1 ? 's' : ''}
                            </p>
                          </div>
                        </div>
                      </button>
                    );
                  })}
                </div>
              )}

              {selectedType && (
                <div className="mt-8 bg-sidebar-bg rounded-xl border border-sidebar-accent overflow-hidden">
                  <div className="px-6 py-4 border-b border-sidebar-accent flex items-center justify-between bg-sidebar-accent/30">
                    <div>
                      <h2 className="text-xl font-bold text-white">
                        Servicios de {selectedType.name}
                      </h2>
                      <p className="text-sm text-gray-400 mt-1">
                        {services.length} servicio{services.length !== 1 ? 's' : ''} configurado{services.length !== 1 ? 's' : ''}
                      </p>
                    </div>
                    <button
                      onClick={() => setShowAddForm(!showAddForm)}
                      className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-all flex items-center gap-2"
                    >
                      {showAddForm ? <CloseIcon sx={{ fontSize: 18 }} /> : <AddIcon sx={{ fontSize: 18 }} />}
                      {showAddForm ? 'Cancelar' : 'Agregar Servicio'}
                    </button>
                  </div>

                  <div className="p-6">
                    {showAddForm && (
                      <div className="mb-6 p-4 bg-sidebar-accent/30 rounded-lg border border-sidebar-accent">
                        <h3 className="text-lg font-semibold text-white mb-4">Nuevo Servicio</h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div>
                            <label className="block text-sm font-medium text-gray-400 mb-2">
                              Título *
                            </label>
                            <input
                              type="text"
                              value={newService.title}
                              onChange={(e) => setNewService({ ...newService, title: e.target.value })}
                              className="w-full px-4 py-2 bg-white rounded-lg text-black border-2 border-sidebar-accent focus:border-blue-500 focus:outline-none"
                              placeholder="Ej: Aceite motor"
                            />
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-400 mb-2">
                              Tipo de servicio
                            </label>
                            <div className="flex gap-2">
                              <button
                                type="button"
                                onClick={() => setNewService({ ...newService, isInspection: false, interval: "", intervalNum: 0 })}
                                className={`flex-1 px-4 py-2 rounded-lg text-sm font-medium transition-all border-2 ${
                                  !newService.isInspection
                                    ? "bg-blue-600 text-white border-blue-600"
                                    : "bg-white text-gray-600 border-sidebar-accent hover:border-blue-400"
                                }`}
                              >
                                Por Kilometraje
                              </button>
                              <button
                                type="button"
                                onClick={() => setNewService({ ...newService, isInspection: true, interval: "0", intervalNum: 0 })}
                                className={`flex-1 px-4 py-2 rounded-lg text-sm font-medium transition-all border-2 ${
                                  newService.isInspection
                                    ? "bg-green-600 text-white border-green-600"
                                    : "bg-white text-gray-600 border-sidebar-accent hover:border-green-400"
                                }`}
                              >
                                Revisión (sin KM)
                              </button>
                            </div>
                          </div>
                          {!newService.isInspection && (
                            <div>
                              <label className="block text-sm font-medium text-gray-400 mb-2">
                                Intervalo (km) *
                              </label>
                              <input
                                type="text"
                                value={newService.interval}
                                onChange={(e) => handleIntervalChange(e.target.value, true)}
                                className="w-full px-4 py-2 bg-white rounded-lg text-black border-2 border-sidebar-accent focus:border-blue-500 focus:outline-none"
                                placeholder="Ej: 10.000"
                              />
                            </div>
                          )}
                          <div className={newService.isInspection ? "md:col-span-2" : ""}>
                            <label className="block text-sm font-medium text-gray-400 mb-2">
                              Descripción
                            </label>
                            <textarea
                              value={newService.description}
                              onChange={(e) => setNewService({ ...newService, description: e.target.value })}
                              className="w-full px-4 py-2 bg-white rounded-lg text-black border-2 border-sidebar-accent focus:border-blue-500 focus:outline-none"
                              placeholder="Descripción del servicio"
                              rows={2}
                            />
                          </div>
                        </div>
                        <div className="mt-4 flex gap-2">
                          <button
                            onClick={handleAddService}
                            disabled={loading}
                            className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-all flex items-center gap-2 disabled:opacity-50"
                          >
                            <SaveIcon sx={{ fontSize: 18 }} />
                            Guardar
                          </button>
                          <button
                            onClick={() => {
                              setShowAddForm(false);
                              setNewService({ title: "", interval: "", intervalNum: 0, description: "", isInspection: false });
                            }}
                            className="px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-lg transition-all"
                          >
                            Cancelar
                          </button>
                        </div>
                      </div>
                    )}

                    {services.length === 0 ? (
                      <div className="text-center py-12 text-gray-400">
                        <BuildCircleIcon sx={{ fontSize: 48 }} className="mb-4" />
                        <p>No hay servicios configurados para este tipo de vehículo</p>
                        <p className="text-sm mt-2">Haz clic en "Agregar Servicio" para comenzar</p>
                      </div>
                    ) : (
                      <div className="overflow-x-auto bg-sidebar-bg">
                        <table className="w-full bg-sidebar-bg">
                          <thead className="bg-sidebar-accent">
                            <tr className="border-b border-sidebar-accent">
                              <th className="text-left py-3 px-4 text-sm font-semibold text-gray-400">Título</th>
                              <th className="text-left py-3 px-4 text-sm font-semibold text-gray-400">Intervalo</th>
                              <th className="text-left py-3 px-4 text-sm font-semibold text-gray-400">Descripción</th>
                              <th className="text-right py-3 px-4 text-sm font-semibold text-gray-400">Acciones</th>
                            </tr>
                          </thead>
                          <tbody className="bg-[#242424]" >
                            {services.map((service) => (
                              <tr key={service._id} className="border-b border-sidebar-accent/50 hover:bg-sidebar-accent/20">
                                {editingService?._id === service._id ? (
                                  <>
                                    <td className="py-3 px-4">
                                      <input
                                        type="text"
                                        value={editingService.title}
                                        onChange={(e) => setEditingService({ ...editingService, title: e.target.value })}
                                        className="w-full px-3 py-1 bg-white rounded text-black border-2 border-blue-500 focus:outline-none"
                                      />
                                    </td>
                                    <td className="py-3 px-4">
                                      <input
                                        type="text"
                                        value={editingService.interval}
                                        onChange={(e) => handleIntervalChange(e.target.value, false)}
                                        className="w-full px-3 py-1 bg-white rounded text-black border-2 border-blue-500 focus:outline-none"
                                      />
                                    </td>
                                    <td className="py-3 px-4">
                                      <input
                                        type="text"
                                        value={editingService.description || ""}
                                        onChange={(e) => setEditingService({ ...editingService, description: e.target.value })}
                                        className="w-full px-3 py-1 bg-white rounded text-black border-2 border-blue-500 focus:outline-none"
                                      />
                                    </td>
                                    <td className="py-3 px-4">
                                      <div className="flex items-center justify-end gap-2">
                                        <button
                                          onClick={() => handleUpdateService(service._id)}
                                          disabled={loading}
                                          className="p-2 bg-green-600 hover:bg-green-700 text-white rounded transition-all disabled:opacity-50"
                                        >
                                          <SaveIcon sx={{ fontSize: 18 }} />
                                        </button>
                                        <button
                                          onClick={() => setEditingService(null)}
                                          className="p-2 bg-gray-600 hover:bg-gray-700 text-white rounded transition-all"
                                        >
                                          <CloseIcon sx={{ fontSize: 18 }} />
                                        </button>
                                      </div>
                                    </td>
                                  </>
                                ) : (
                                  <>
                                    <td className="py-3 px-4 text-white font-medium">{service.title}</td>
                                    <td className="py-3 px-4">
                                      {(!service.intervalNum || service.intervalNum === 0) ? (
                                        <span className="px-2 py-1 bg-green-500/20 text-green-400 text-xs font-medium rounded-full">
                                          Revisión
                                        </span>
                                      ) : (
                                        <span className="text-gray-300">{service.interval} km</span>
                                      )}
                                    </td>
                                    <td className="py-3 px-4 text-gray-400 text-sm">{service.description || '-'}</td>
                                    <td className="py-3 px-4">
                                      <div className="flex items-center justify-end gap-2">
                                        <button
                                          onClick={() => setEditingService(service)}
                                          className="p-2 bg-blue-600 hover:bg-blue-700 text-white rounded transition-all"
                                        >
                                          <EditIcon sx={{ fontSize: 18 }} />
                                        </button>
                                        <button
                                          onClick={() => handleDeleteService(service._id)}
                                          disabled={loading}
                                          className="p-2 bg-red-600 hover:bg-red-700 text-white rounded transition-all disabled:opacity-50"
                                        >
                                          <DeleteIcon sx={{ fontSize: 18 }} />
                                        </button>
                                      </div>
                                    </td>
                                  </>
                                )}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </Wrapper>
      </div>
      <Snackbar
        severity={snack.severity}
        message={snack.message}
        visible={snack.visible}
      />
    </div>
  );
};
